import { render, staticRenderFns } from "./Visions.vue?vue&type=template&id=087216bb&"
import script from "./Visions.vue?vue&type=script&lang=js&"
export * from "./Visions.vue?vue&type=script&lang=js&"
import style0 from "./Visions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports